<script setup></script>
<template>
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="5.33203" y="8" width="21.3333" height="16" rx="2" stroke="currentColor" stroke-width="1"/>
        <path d="M5.33203 12L15.1043 16.8861C15.6673 17.1676 16.3301 17.1676 16.8931 16.8861L26.6654 12" stroke="currentColor" stroke-width="1"/>
    </svg>
</template>